import { useQuery } from '@tanstack/react-query';
import {
  complianceDashboardApi,
  type ComplianceDashboardSummary,
} from '../api/services/compliance-dashboard';

export function useComplianceDashboardSummary() {
  return useQuery<ComplianceDashboardSummary>({
    queryKey: ['admin', 'compliance-dashboard', 'summary'],
    queryFn: () => complianceDashboardApi.getSummary(),
  });
}

export function useRegulationUTrend(days?: number) {
  return useQuery({
    queryKey: ['admin', 'compliance-dashboard', 'regulation-u-trend', days],
    queryFn: () => complianceDashboardApi.getRegulationUTrend(days),
  });
}

export function useRiskDistribution() {
  return useQuery({
    queryKey: ['admin', 'compliance-dashboard', 'risk-distribution'],
    queryFn: () => complianceDashboardApi.getRiskDistribution(),
  });
}

export function useEddReports() {
  return useQuery({
    queryKey: ['admin', 'compliance-dashboard', 'edd-reports'],
    queryFn: () => complianceDashboardApi.getEddReports(),
  });
}

export function useComplianceDashboardAlerts(hours?: number) {
  return useQuery({
    queryKey: ['admin', 'compliance-dashboard', 'alerts', hours],
    queryFn: () => complianceDashboardApi.getAlerts(hours),
  });
}
